<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <OrdersTable :list.sync="items" class="mt-3" />
                    <CPagination
                        :active-page.sync="activePage"
                        class="mt-4"
                        :pages="total"
                        align="center"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import OrdersTable from '@/components/orders/OrdersTable';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';
    const { ITEMS_PER_PAGE } = require('../../utils/views');

    export default {

        name: 'PartnerOrders',

        components: {
            PartnersTabLinks,
            OrdersTable,
        },

        data() {
            return {
                entity: undefined,
                items: [],
                total: 1,
            };
        },

        computed: {
            activePage: {
                get() {
                    return parseInt(this.$route.query.page) || 1;
                },
                async set(v) {
                    const query = { page: v };
                    this.$router.push({ query });
                },
            },
        },

        watch: {
            activePage: 'loadData',
        },

        async created() {
            await this.fetch();
            this.loadData();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/partners/${id}`)).data;
            },
            loadData() {
                const { id } = this.$route.params;
                const params = { page: this.activePage, pageSize: ITEMS_PER_PAGE, partner_id: id };
                this.axios
                    .get('/orders', { params })
                    .then(resp => {
                        this.items = resp.data.results;
                        this.total = Math.ceil(resp.data.total / ITEMS_PER_PAGE);
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки заказов. ' + err);
                    });
            },
            pageChange(val) {
                this.$router.push({ query: { page: val } });
            },
        },
    };
</script>
